import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import {
  isInjectionValid,
  isTokenExpired,
  clearExpiredToken,
} from "../libs/utils";
import { useEffect } from "react";
import { store, persistor } from "../redux/";
import Header from "../components/layout/header";
import Footer from "../components/layout/footer";
import { useRouter } from "next/router";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/stores/auth";
import { decrypt } from "../libs/encryption";

// Token kontrolü yapacak component
function TokenChecker() {
  const dispatch = useDispatch();
  const router = useRouter();
  const token = useSelector((state) => state.auth.authorization);
  const isLoggedIn = useSelector((state) => state.auth.loggedIn);

  useEffect(() => {
    // Sadece logged in kullanıcılar için token kontrol et
    if (isLoggedIn) {
      try {
        const decryptedToken = decrypt(token);
        if (isTokenExpired(decryptedToken)) {
          // Token expired, kullanıcıyı logout yap
          clearExpiredToken();
          dispatch(logout());

          // Eğer kullanıcı user sayfalarındaysa login'e yönlendir
          if (router.pathname.startsWith("/user/")) {
            router.push("/login");
          }
        }
      } catch (error) {
        console.warn("Token kontrol hatası:", error);
        // Token decode edilemezse, güvenlik için logout yap
        clearExpiredToken();
        dispatch(logout());
      }
    }
  }, [token, isLoggedIn, dispatch, router]);

  return null; // Bu component görsel bir şey render etmez
}

export default function App({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    import("../public/static/js/vendors/slick.js");
    import("../public/static/js/vendors/noUISlider.js");
    import("../public/static/js/main.js");
    import("../public/static/js/shop.js");
  });

  useEffect(() => {
    if (isInjectionValid(router.query.slug) === true) {
      router.push("/notfound");
      return;
    }
  }, []);

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <TokenChecker />
          <header>
            <Header />
          </header>
          <Component {...pageProps} />
          <footer className="footer">
            <Footer />
          </footer>
        </PersistGate>
      </Provider>
    </>
  );
}
